import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { FiExternalLink, FiStar } from "react-icons/fi";
import { projects } from "../data/projects";
import "./Projects.css";

const ProjectCard = ({ project, index, inView }) => (
  <motion.div
    className={`project-card${project.featured ? " project-card--featured" : ""}`}
    initial={{ opacity: 0, y: 20 }}
    animate={inView ? { opacity: 1, y: 0 } : {}}
    transition={{ duration: 0.4, delay: index * 0.08 }}
  >
    {project.featured && (
      <div className="project-card__badge">
        <FiStar size={12} /> Featured
      </div>
    )}
    <div className="project-card__content">
      <h3 className="project-card__title">{project.title}</h3>
      <p className="project-card__desc">{project.description}</p>

      <p className="project-card__role">
        <strong>Role:</strong> {project.role}
      </p>

      <div className="project-card__tech">
        {project.tech.map((t, i) => (
          <span key={i} className="project-card__tech-tag">
            {t}
          </span>
        ))}
      </div>

      <ul className="project-card__highlights">
        {project.highlights.map((h, i) => (
          <li key={i}>{h}</li>
        ))}
      </ul>

      <a
        href={project.url}
        className="btn btn--sm btn--primary"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FiExternalLink size={14} /> View Live
      </a>
    </div>
  </motion.div>
);

const Projects = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.05 });

  return (
    <section id="projects" className="projects section" ref={ref}>
      <div className="container">
        <motion.div
          className="section__header"
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5 }}
        >
          <span className="section__label">Projects</span>
          <h2 className="section__title">Real-World Work</h2>
        </motion.div>

        <div className="projects__grid">
          {projects.map((project, i) => (
            <ProjectCard
              key={project.id}
              project={project}
              index={i}
              inView={inView}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
